import styled from "@emotion/styled";
import { Button, Select } from "antd";
import { checkHasValue } from "utils/general";

export const Label = styled.p`
  margin-bottom: ${(props) => props.theme.spacing.xxs};
`;

export const DescriptionForLabel = styled.p`
  font-weight: ${(props) => props.theme.fontWeight.light};
  font-style: italic;
  margin-bottom: ${(props) => props.theme.spacing.xxs};
`;

export const FinancialTitleText = styled.div`
  text-align: center;
`;

export const FinancialValueText = styled.div`
  text-align: center;
  color: ${(props) =>
    checkHasValue(props.isInRange) && !props.isInRange && "red"};
`;

export const ExtraInfoText = styled.span`
  font-style: italic;
  font-weight: ${(props) => props.theme.fontWeight.light};
`;

export const CardContainer = styled.div`
  background-color: ${(props) => props.theme.color.secondary};
  border-radius: 16px;
  box-shadow: 0 3px 8px ${(props) => props.theme.color.primary}33;
  color: ${(props) => props.theme.color.primary};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: ${(props) => props.theme.spacing.regular}
    ${(props) => props.theme.spacing.regular};
  text-align: center;
`;

export const CoverageLabel = styled.p`
  font-size: 16px;
  font-weight: ${(props) => props.theme.fontWeight.bold};
  margin-bottom: 0;
`;

export const CoveragePriceText = styled.p`
  font-size: 32px;
  font-weight: ${(props) => props.theme.fontWeight.bold};
  margin-bottom: 0;
`;

export const CoverageYearText = styled.p`
  font-size: 16px;
  margin-bottom: ${(props) => props.theme.spacing.xxs};
`;

export const GhostButton = styled(Button)`
  border-color: ${(props) => props.theme.color.complementary};
  background-color: ${(props) => props.theme.color.white};
  color: ${(props) => props.theme.color.complementary};
`;

export const Selection = styled(Select)`
  width: 200px;
  margin-left: 4px;
`;
